import { type FC, useEffect, useMemo, useState } from "react";

const PATTERNS = {
  small: ["⠟", "⠯", "⠷", "⠾", "⠽", "⠻"],
  large: ["⡿", "⣟", "⣯", "⣷", "⣾", "⣽", "⣻", "⢿"],
};

export interface TextSpinnerProps {
  size?: "small" | "large";
}

export const TextSpinner: FC<TextSpinnerProps> = (props) => {
  const [text, setText] = useState("");
  const frames = useMemo(() => (props.size === "large" ? PATTERNS.large : PATTERNS.small), [props.size]);

  useEffect(() => {
    let i = 0;

    const interval = setInterval(() => {
      setText(getTextFrame(i));
      i = (i + 1) % frames.length;
    }, 100);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [frames]);

  const getTextFrame = (index: number) => {
    return frames[index];
  };

  return text;
};
